<template>
  <div>
    <!-- Card -->
    <div class="bg-white border rounded-lg shadow p-4">
      <!-- Header -->
      <div class="flex justify-between items-center mb-4">
        <div class="text-xl font-bold text-primary">Authorization Mode Summary</div>

        <!-- Export Button -->
        <button
          class="bg-primary text-white px-4 py-2 rounded-lg shadow hover:bg-green-700 transition"
          @click="downloadCsv"
        >
          ⬇ Export CSV
        </button>
        <download-csv
          :data="exportData"
          name="auth_mode_summary.csv"
          class="hidden"
          ref="exportCsv" 
        />
      </div>

      <!-- Chart -->
      <div class="px-2">
        <canvas id="auth-mode-graph" class="w-full h-64"></canvas>
      </div>

      <!-- Custom Legend Badges -->
      <div class="flex flex-wrap gap-2 mt-4">
        <span
          v-for="(label, index) in chartData.labels"
          :key="index"
          class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium text-white shadow"
          :style="{ backgroundColor: chartData.datasets[0].backgroundColor[index] }"
        >
          {{ label }}: {{ chartData.datasets[0].data[index] }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import GraphQl from "../../services/graphql.service";
import moment from "moment";
import Chart from "chart.js";

export default {
  name: "AuthModeSummary",
  props: {
    filters: Object,
  },
  data() {
    return {
      chart: null,
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Connections",
            data: [],
            backgroundColor: [             
              "#2563eb",
              "#6b7280",
              "#10b981",
              "#3b82f6",
              "#f59e0b",
              "#9333ea",
              "#0d9488",
             
            ],
          },
        ],
      },
      exportData: [],
    };
  },
  mounted() {
    this.initChart();
    this.loadStats();
  },
  watch: {
    filters: {
      handler() {
        this.loadStats();
      },
      deep: true,
    },
  },
  methods: {
    initChart() {
      const ctx = document.getElementById("auth-mode-graph");
      this.chart = new Chart(ctx, {
        type: "pie",
        data: this.chartData,
        options: {
          responsive: true,
          legend: {
            display: false, // hide default legend
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                let value =
                  data.datasets[tooltipItem.datasetIndex].data[
                    tooltipItem.index
                  ] || 0;
                let label = data.labels[tooltipItem.index] || "";
                return `${label}: ${value.toLocaleString()}`;
              },
            },
          },
        },
      });
    },
    loadStats() {
      let v = [];
      this.filters.venues.forEach((venue) => {
        v.push(venue.id);
      });

      let params =
        (this.filters.venues.length > 0
          ? 'venues:["' + v.join('","') + '"],'
          : "") +
        'startDate: "' +
        moment(this.filters.dateRange.startDate).format("YYYY-MM-DD 00:00:00") +
        '", ' +
        'endDate: "' +
        moment(this.filters.dateRange.endDate).format("YYYY-MM-DD 23:59:59") +
        '"';

      // Reset chart data
      this.chartData.labels = [];
      this.chartData.datasets[0].data = [];
      this.exportData = [];

      GraphQl.sendRequest(
        "{aggregateAuthModeSummary(" + params + "){mode connections}}"
      ).then((response) => {
        response.aggregateAuthModeSummary.forEach((stat) => {
          this.chartData.labels.push(stat.mode);
          this.chartData.datasets[0].data.push(stat.connections);
          this.exportData.push({
            Mode: stat.mode,
            Connections: stat.connections,
          });
        });

        this.chart.update();
      });
    },
    downloadCsv() {
      this.$refs.exportCsv.generate();
    },
  },
};
</script>
